import React from "react";
import MainBanner from "../components/sections/inicio/lienzoprincipal/main_banner";
import Nav from "../components/sections/inicio/navegador/navegador";
import Statistics from "../components/sections/inicio/estadisticas/statistics";
import ProgBanner from "../components/sections/inicio/lienzoprogramas/prog_banner";
import Companies from "../components/sections/inicio/organizaciones/companies";
import Proposito from "../components/sections/inicio/proposito/proposito";
import Mujeres from "../components/sections/inicio/mujeres/mujeres";
import Redes from "../components/sections/inicio/redessociales/rrss";

const componentMapping = {
  main_banner: MainBanner,
  navegador: Nav,
  companies: Companies,
  statistics: Statistics,
  prog_banner: ProgBanner,
  proposito: Proposito,
  mujeres: Mujeres,
  rrss: Redes,
};

const HomePage = () => {
  return (
    <>
      {Object.entries(componentMapping).map(([id, Component]) => (
        <div key={id} id={id} className="page-section">
          <Component />
        </div>
      ))}
      {/* <DonationPopup /> */}
    </>
  );
};

export default HomePage;
